import { lang } from "constant/lang";
import React from "react";
import Button from "components/Button/Button";
import question from "images/pattern/question.svg";
import stars2 from "images/pattern/stars-2.svg";
import waveYellow from "images/pattern/wave-yellow.svg";
import { Link } from "react-router-dom";

const InfoSection = () => {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-10 xs:gap-20">
      <div className="flex flex-col relative sm:min-w-[390px]">
        <span className="mb-4 relative w-fit">
          <span className="font-yesevaOne text-3xl xs:text-5xl text-wce-navy-light">
            {lang.homepage.info.left.what}
          </span>
          <div className="absolute translate-x-full -right-2 -top-8">
            <img
              className="w-[72px] min-w-[72px]"
              src={question}
              alt={"question"}
            />
          </div>
        </span>
        <span
          className="inline-flex items-center px-4 font-yesevaOne text-3xl xs:text-5xl h-[56px] xs:h-[66px]
            text-wce-pink-bright bg-wce-yellow-light w-fit rounded-2xl mb-4"
        >
          {lang.homepage.info.left.weekend}
        </span>
        <span
          className="inline-flex items-center px-4 font-yesevaOne text-3xl xs:text-5xl h-[56px] xs:h-[66px]
            text-wce-pink-bright bg-wce-yellow-light w-fit rounded-2xl"
        >
          {lang.homepage.info.left.career}
        </span>
        <div className="border-dotted border-t-[10px] border-wce-pink-bright my-6 xs:my-10 w-full" />
        <div className="w-full">
          <Link to="/about-us">
            <Button
              size="large"
              rounded
              variant="secondary"
              color="danger"
              className="w-full"
            >
              Learn More About Us
            </Button>
          </Link>
        </div>
      </div>
      <div
        className="flex flex-col z-10 bg-white rounded-2xl border-2 border-white
          p-6 shadow-wce-hard relative gap-[10px] text-wce-neutral-8"
      >
        <div className="absolute translate-x-1/2 right-8 -top-8 xs:-top-14">
          <img
            className="w-[60px] min-w-[60px] xs:w-[114px] xs:min-w-[114px]"
            src={stars2}
            alt={"stars2"}
          />
        </div>
        <div className="absolute translate-x-1/2 right-8 -bottom-6">
          <img
            className="w-[114px] min-w-[114px]"
            src={waveYellow}
            alt={"waveYellow"}
          />
        </div>
        <span>{lang.homepage.info.right.p1}</span>
        <span>
          {lang.homepage.info.right.p2}
          <ol className="ml-6 list-decimal">
            {lang.homepage.info.right.p3.map((pnum) => (
              <li>{pnum}</li>
            ))}
          </ol>
        </span>
        {lang.homepage.info.right.p4}
      </div>
    </div>
  );
};

export default InfoSection;
